import Box from "../components/Box";

function SettingsPage() {
    return (
        <Box>
            <h1>Settings</h1>
                
                <h6>
                    Change your settings!
                </h6>
        </Box>
    );
}

export default SettingsPage;